/**
 * Design-QA route for the Settings screen (mirrors ProfileReview).
 * Mounts <SettingsView> with fabricated data — no Supabase session needed.
 * Variants:
 *
 *   /settings-review               — email user with an uploaded photo
 *   /settings-review?state=google  — Google user (sync row visible)
 *   /settings-review?state=busy    — upload in flight (trailing spinner)
 *   /settings-review?state=notice  — inline avatar validation error
 */
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { SettingsView } from './screens/Settings.js';

const noop = () => undefined;

export function SettingsReview() {
  const [params] = useSearchParams();
  const variant = params.get('state') ?? 'default';
  const [goal, setGoal] = useState<5 | 10 | 15 | 20>(10);
  const [newCards, setNewCards] = useState<5 | 10 | 15 | 20>(10);
  const [locale, setLocale] = useState<'ka' | 'en'>('ka');
  const [soundOn, setSoundOn] = useState(true);

  return (
    <SettingsView
      data={{
        displayName: 'ნინო ბერიძე',
        email: 'nino.beridze@example.com',
        avatarUrl: variant === 'google' ? undefined : 'about:blank',
        hasOauthPicture: variant === 'google',
        avatarBusy: variant === 'busy' ? 'upload' : null,
        avatarNotice: variant === 'notice' ? 'ფაილი ძალიან დიდია — მაქს. 2 MB' : null,
        goal,
        newCards,
        locale,
        soundOn,
      }}
      onBack={noop}
      onPickAvatar={noop}
      onSyncOAuth={noop}
      onRemoveAvatar={noop}
      onChangeGoal={setGoal}
      onChangeNewCards={setNewCards}
      onChangeLocale={setLocale}
      onToggleSound={setSoundOn}
      onConfirmDelete={() => new Promise((r) => setTimeout(() => r(false), 800))}
    />
  );
}
